import { render } from "./SinglePageCandle.vue?vue&type=template&id=85918b8c&lang=html"
import script from "./SinglePageCandle.vue?vue&type=script&lang=js"
export * from "./SinglePageCandle.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__